import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {},
    menuRoot: {
        display: 'flex',
        marginRight: '10px',
    },
    entityInfo: {
        display: 'flex',
        alignItems: 'center',
    },
    entityIcon: {
        width: theme?.common?.logo?.width || '44px',
        height: '44px',
    },
    entityDetails: {
        margin: '0 30px',
        maxWidth: 500,
        textOverflow: 'ellipsis',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
    },
    entityLabel: {
        fontSize: '11px',
        textTransform: 'uppercase',
    },
    entityName: {
        fontWeight: 'bold',
        fontSize: '16px',
    },
}));
